import * as SessionAPI from './actions/Session';
import * as DriveAPI from './actions/Drive';
import * as UserAPI from './actions/User';
import * as AdminAPI from './actions/Admin';
import * as SuppliesAPI from './actions/Supplies';
import * as SupplyAPI from './actions/Supply';
import * as EntityAPI from './actions/Entity';
import * as DocumentsAPI from './actions/Documents';

export const Session = SessionAPI;
export const Drive = DriveAPI;
export const User = UserAPI;
export const Admin = AdminAPI;
export const Supplies = SuppliesAPI;
export const Supply = SupplyAPI;
export const Entity = EntityAPI;
export const Documents = DocumentsAPI;

const all = {
    Session,
    Drive,
    User,
    Admin,
    Supplies,
    Supply,
    Entity,
    Documents,
};

export default all;
